import useStoreSelector from "common/redux/useStoreSelector";
import { Producer } from "./producer";
import producerService from "./producerService";
import _ from "lodash";
import { useEffect } from "react";

const getCached = _.memoize(async () => {
    return await producerService.getMyProducer();
});

let producer: Producer = null;

export default function useMyProducer(): Producer {
    const isCustomer = useStoreSelector(m => m.userState.isCustomer);

    useEffect(() => {
        if (!isCustomer) return;

        getCached().then(m => producer = m);
    }, [isCustomer])

    return producer;

}